import { create } from "zustand";
import { persist } from "zustand/middleware";

// Which storefront tenant a BOOTSTRAP_SUPER admin is currently administering
// (BLK-API-015). The api-client sends the tenant `id` as `X-Tenant-Override` on
// every /admin request; the `code` is kept for public reads that resolve the
// tenant from `X-Tenant-Code`. The backend honors the override only for
// bootstrap-level principals, so persisting it is safe — for anyone else the
// header is ignored server-side.
export interface TenantSelection {
  id: string;
  code?: string | undefined;
}

interface TenantOverrideState {
  tenantId: string | null;
  tenantCode: string | null;
  setTenant: (tenant: TenantSelection | null) => void;
}

export const useTenantOverride = create<TenantOverrideState>()(
  persist(
    (set) => ({
      tenantId: null,
      tenantCode: null,
      setTenant: (tenant) =>
        set({ tenantId: tenant?.id ?? null, tenantCode: tenant?.code ?? null }),
    }),
    { name: "ntr_admin_tenant_override", version: 2 },
  ),
);
